import React, { useState, useEffect } from 'react';
import { feesAPI } from '../../../services/api';
import '../Shared/FormStyles.scss';

const FeesManager = () => {
  const [fees, setFees] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editing, setEditing] = useState(null);
  const [formData, setFormData] = useState({
    category: 'General',
    label: '',
    price: '',
    order: 0,
    isActive: true,
  });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => {
    fetchFees();
  }, []);

  const fetchFees = async () => {
    try {
      const response = await feesAPI.getAllAdmin();
      setFees(response.data);
    } catch (err) {
      setError('Failed to fetch fees');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    try {
      if (editing) {
        await feesAPI.update(editing._id, formData);
        setSuccess('Fee updated successfully');
      } else {
        await feesAPI.create(formData);
        setSuccess('Fee created successfully');
      }
      resetForm();
      fetchFees();
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to save fee');
    }
  };

  const handleEdit = (fee) => {
    setEditing(fee);
    setFormData({
      category: fee.category || 'General',
      label: fee.label || '',
      price: fee.price || '',
      order: fee.order || 0,
      isActive: fee.isActive !== undefined ? fee.isActive : true,
    });
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this fee?')) return;
    try {
      await feesAPI.delete(id);
      setSuccess('Fee deleted successfully');
      fetchFees();
    } catch (err) {
      setError('Failed to delete fee');
    }
  };

  const resetForm = () => {
    setEditing(null);
    setFormData({ category: 'General', label: '', price: '', order: 0, isActive: true });
  };

  if (loading) return <div>Loading...</div>;

  return (
    <div className="fees-manager">
      <div className="admin-form">
        <h2>{editing ? 'Edit Fee' : 'Add New Fee'}</h2>
        {error && <div className="error-message">{error}</div>}
        {success && <div className="success-message">{success}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Category</label>
            <input
              type="text"
              value={formData.category}
              onChange={(e) => setFormData({ ...formData, category: e.target.value })}
              placeholder="e.g. Initial Consultation, Follow-up"
            />
          </div>
          <div className="form-group">
            <label>Label *</label>
            <input
              type="text"
              value={formData.label}
              onChange={(e) => setFormData({ ...formData, label: e.target.value })}
              required
              placeholder="e.g. Initial Consultation (45 min)"
            />
          </div>
          <div className="form-group">
            <label>Price *</label>
            <input
              type="text"
              value={formData.price}
              onChange={(e) => setFormData({ ...formData, price: e.target.value })}
              required
              placeholder="e.g. $95 or $95 – $120"
            />
          </div>
          <div className="form-group">
            <label>Display Order</label>
            <input
              type="number"
              value={formData.order}
              onChange={(e) => setFormData({ ...formData, order: parseInt(e.target.value) || 0 })}
              min="0"
            />
          </div>
          <div className="form-group">
            <label>
              <input
                type="checkbox"
                checked={formData.isActive}
                onChange={(e) => setFormData({ ...formData, isActive: e.target.checked })}
              />
              {' '}Active (visible on website)
            </label>
          </div>
          <div className="form-actions">
            <button type="submit" className="dashboard-btn btn-primary">
              {editing ? 'Update Fee' : 'Create Fee'}
            </button>
            {editing && (
              <button type="button" className="dashboard-btn btn-secondary" onClick={resetForm}>
                Cancel
              </button>
            )}
          </div>
        </form>
      </div>

      <div className="data-table" style={{ marginTop: '30px' }}>
        <h2 style={{ padding: '20px', margin: 0 }}>All Fees ({fees.length})</h2>
        {fees.length === 0 ? (
          <div className="empty-state">No fees yet. Add your first fee above.</div>
        ) : (
          <table>
            <thead>
              <tr>
                <th>Order</th>
                <th>Category</th>
                <th>Label</th>
                <th>Price</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {fees.map((fee) => (
                <tr key={fee._id}>
                  <td>{fee.order}</td>
                  <td>{fee.category}</td>
                  <td>{fee.label}</td>
                  <td>{fee.price}</td>
                  <td>{fee.isActive ? 'Active' : 'Inactive'}</td>
                  <td>
                    <div className="table-actions">
                      <button className="btn-edit" onClick={() => handleEdit(fee)}>Edit</button>
                      <button className="btn-delete" onClick={() => handleDelete(fee._id)}>Delete</button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default FeesManager;
